import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Storage } from '@ionic/storage';
import { element } from 'protractor';
import { DialogData } from 'src/app/common/delete-alert/delete-alert.component';
import { SalesInvoiceService } from 'src/app/home/sales/sales-invoice/sales-invoice.service';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-multigodown-selection',
  templateUrl: './multigodown-selection.component.html',
  styleUrls: ['./multigodown-selection.component.scss']
})
export class MultigodownSelectionComponent implements OnInit {
  responseData: any;
  btnClicked = false;
  loadingTrue = false;
  buttonClicked = false;
  displayedColumns: any = ['godownname', 'qty', 'godowncode'];
  selectedItem: any = {
    ic: '',
    ina: '',
    qty: '',
  };
  godowndetails = {
    godowncode: '',
    godownname: '',
    stock: '',
    avlstock: '',
    qty: ''
  };
  entryname = '';
  godowns: any = [];
  godowndetail = [];
  disableTrue = true;
  reloadTrue = false;
  // @ViewChild('selectGodown', { static: false }) selectGodown;
  searchitem = '';
  scanbarcode = '';
  sbc = '';
  bbc = '';
  bc = '';
  barcode = '';
  responseData1: any;
  constructor(
    public dialogRef: MatDialogRef<MultigodownSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public xdata: DialogData,
    public data: DataService,
    public storage: Storage
  ) {
    this.responseData = this.xdata;
    this.responseData1 = this.xdata
    console.log(this.responseData)
    this.selectedItem.ic = this.responseData.ic;
    this.selectedItem.ina = this.responseData.ina;
    this.selectedItem.qty = this.responseData.qty;
    this.entryname = this.responseData.entryname;
    if (this.responseData.godowndetail !== null) {
      this.godowndetail = this.responseData.godowndetail;
    }
    this.scanbarcode = this.responseData.scanbarcode;
    this.sbc = this.responseData.sbc;
    this.bbc = this.responseData.bbc;
    this.barcode = this.responseData.barcode;
    if (this.scanbarcode === 'SCANBARCODE') {
      this.bc = this.sbc;
    } else if (this.barcode === 'BARCODE') {
      this.bc = this.bbc
    } else {
      this.bc = '';
    }
    console.log(this.godowndetail)
  }

  ngOnInit(): void {
    this.getGodownStocks();
    //  this.invoiceService.godowns = this.responseData.items;
  }

  onNoClick(): void {
    this.clearGodownDetails();
    this.godowndetail = [];
    this.dialogRef.close();
  }

  getGodownStocks() {
    const obj = {
      ic: this.selectedItem.ic,
      searchitem: this.searchitem,
      matrix1code: this.responseData1.matrix1code,
      matrix2code: this.responseData1.matrix2code,
      matrix3code: this.responseData1.matrix3code,
      matrix4code: this.responseData1.matrix4code,
      matrix5code: this.responseData1.matrix5code,
      matrix6code: this.responseData1.matrix6code,
      matrix7code: this.responseData1.matrix7code,
      matrix8code: this.responseData1.matrix8code,
      matrix9code: this.responseData1.matrix9code,
      matrix10code: this.responseData1.matrix10code,
      batchno: this.responseData1.batchno,
      entryupdatemode: 'NO',
      entryname: this.entryname,
      entryno: '',
      entrybranchcode: '',
      entryfinyearcode: '',
      bc: this.bc
    };

    if (this.responseData1.addCal) {
      obj.bc = this.responseData1.bc,
        obj.matrix1code = this.responseData1.matrix1code,
        obj.matrix2code = this.responseData1.matrix2code,
        obj.matrix3code = this.responseData1.matrix3code,
        obj.matrix4code = this.responseData1.matrix4code,
        obj.matrix5code = this.responseData1.matrix5code,
        obj.matrix6code = this.responseData1.matrix6code,
        obj.matrix7code = this.responseData1.matrix7code,
        obj.matrix8code = this.responseData1.matrix8code,
        obj.matrix9code = this.responseData1.matrix9code,
        obj.matrix10code = this.responseData1.matrix10code,
        obj.batchno = this.responseData1.batchno
    }
    console.log(this.responseData1, obj)
    this.data.postData('search/godownstocks', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.godowns = this.responseData.data;
        this.godowns.forEach(element => {
          element.avlstock = element.stock;
        });
        if (this.responseData1.addCal === undefined) {
          this.doAddCalc();
        }

      } else {
        this.godowns = [];
      }
      this.loadingTrue = false;
    }, (error) => {
      this.data.errorResponse(error);
    });
  }
  onSelect(event) {
    this.godowndetails.qty = this.godowndetails.avlstock
  }

  goNext() {
    if (this.godowndetail.length !== 0) {
      this.dialogRef.close({
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        godowndetail: this.godowndetail,
        select: true
      });
    } else { this.data.openAlertFalse('Add Godown Qty'); }
  }

  valadd() {

    if (this.responseData1.addCal === undefined) {
      if (this.godowndetails.godowncode !== '' && this.godowndetails.qty !== '' && this.godowndetails.qty !== '0') {
        if (parseFloat(this.godowndetails.qty) <= parseFloat(this.godowndetails.avlstock)) {
          this.itemAdd();
        } else { this.data.openAlertFalse('Qty is more than Stock'); }
      }
    }
    else {
      if (parseFloat(this.godowndetails.qty) <= parseFloat(this.godowndetails.avlstock)) {
        this.godowns.forEach(element => {
          if (element.godowncode === this.godowndetails.godowncode) {
            element.avlstock = (parseFloat(element.avlstock) - parseFloat(this.godowndetails.qty)).toString();
          }
        });
       
        this.itemAdd();
      }
      else { this.data.openAlertFalse('Qty is more than Stock'); }
    }
  }

  itemAdd() {
    if (this.godowndetails.godowncode !== '') {
      const obj = {
        godowncode: this.godowndetails.godowncode,
        godownname: this.godowndetails.godownname,
        // stock: this.godowndetails.stock,
        // avlstock: this.godowndetails.avlstock,
        qty: this.godowndetails.qty
      };
      // const xobj = Object.assign(obj, this.godowndetail);
      const index = this.godowndetail.map(e => e.godowncode).indexOf(this.godowndetails.godowncode);
      if (index !== -1) {

        this.godowndetail[index].qty = (parseFloat(this.godowndetail[index].qty) + parseFloat(this.godowndetails.qty)).toString();
      } else { this.godowndetail.push(obj); }
      this.reloadTrue = true;
      setTimeout(() => {
        this.reloadTrue = false;
      }, 400);
      this.clearGodownDetails();
      if (this.responseData1.addCal === undefined) {
        this.doAddCalc();
      }
      else{
        let total = 0
        this.godowndetail.forEach((item) => {
          total = total + parseFloat(item.qty);
        });
        this.selectedItem.qty = total;
      }
    }
  }
  public doAddCalc() {

    if (this.godowndetail.length > 0) {
      let total = 0;
      this.godowndetail.forEach((item) => {
        total = total + parseFloat(item.qty);
        this.godowns.forEach((data) => {
          if (item.godowncode === data.godowncode) {
            data.avlstock = (parseFloat(data.stock) - parseFloat(item.qty)).toString();
          }
        });
      });
      this.selectedItem.qty = total;
    }
  }
  clearGodownDetails() {
    this.godowndetails = {
      godowncode: '',
      godownname: '',
      stock: '',
      avlstock: '',
      qty: ''
    };
    // this.selectGodown.clearValue();
  }
  remove(el) {
    const index = this.godowndetail.map((e) => e.godowncode).indexOf(el.godowncode);
    if (index !== -1) {
      this.godowndetail.splice(index, 1);
      if (this.godowns.length > 0) {
        this.godowns.forEach((data) => {
          if (el.godowncode === data.godowncode) {
            if (this.godowndetail.length > 0) {
              let found = false;
              this.godowndetail.forEach((val: any) => {
                if (val.godowncode === el.godowncode) {
                  data.avlstock = (parseFloat(data.stock) + parseFloat(el.qty)).toString();
                  found = true;

                }
              });
              if (!found) {
                data.avlstock = (parseFloat(data.avlstock) + parseFloat(el.qty)).toString();
              }
            }
            else {
              this.godowns.forEach(element => {
                element.avlstock = element.stock;
                this.selectedItem.qty = '';
              });
            }
          }

          else {
            let godownExists = this.godowns.some((element: any) => element.godowncode === el.godowncode);
            console.log(godownExists)
            if (!godownExists) {
              el.stock = el.qty;
              el.avlstock = el.qty;
              this.godowns.push(el);
            }
          }
        });
      }
      else {
        el.stock = el.qty;
        el.avlstock = el.qty;
        this.godowns.push(el);
      }
      if (this.responseData1.addCal === undefined) {
        this.doAddCalc();
      }
      this.reloadTrue = true;
      setTimeout(() => {
        this.reloadTrue = false;
      }, 400);
    }
  }
  // remove(el) {
  //   const indexToRemove = this.godowndetail.findIndex((e) => e.godowncode === el.godowncode);

  //   if (indexToRemove !== -1) {
  //     const removedElement = this.godowndetail[indexToRemove];

  //     if (this.godowndetail.length > 0) {
  //       let found = false;
  //       this.godowndetail.forEach((val) => {
  //         if (val.godowncode === el.godowncode) {
  //           removedElement.avlstock = (parseFloat(removedElement.stock) + parseFloat(el.qty)).toString();
  //           found = true;
  //         }
  //       });
  //       if (!found) {
  //         removedElement.avlstock = removedElement.stock;
  //       }
  //       else {
  //         removedElement.avlstock = removedElement.stock;
  //         this.selectedItem.qty = '';
  //       }
  //     } 
  //     else {
  //       el.stock = el.qty;
  //       el.avlstock = el.qty;
  //       this.godowns.push(el);
  //     }


  //     // Remove the element
  //     this.godowndetail.splice(indexToRemove, 1);

  //     this.doAddCalc();
  //     this.reloadTrue = true;

  //     setTimeout(() => {
  //       this.reloadTrue = false;
  //     }, 400);
  //   }
  // }

}
